import { DateTime } from "luxon";

/**
 * Given a date and a format, return the formatted time.
 */
export function formatTime({ date, format }: { date: DateTime; format: "1:00 pm" }) {
  switch (format) {
    case "1:00 pm":
      return date.toFormat("h:mm a").toLowerCase();
    default:
      throw new Error(`Unsupported format: ${format}`);
  }
}
